import React, { Component } from 'react';

import { useParams, useNavigate, Link, } from 'react-router-dom';
import Pagination from "react-js-pagination";
import { apiUrl} from'../Config/Config';
import { lang } from '../Helpers/lang';
import Select from 'react-select';
import axios from 'axios';
import $ from 'jquery';
import moment from 'moment';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";

//import { GET_CARLIST,GET_DELETECAR,GET_PRIORITYUPDATE } from '../../actions';


const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
};
  
class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      citylist:'',
      activePage: 1,
      totalRecord: '',
      search_all:'',
      selectedStatus:'',
      selectid:'',
      cityid:'',
      
      selectedFilOption:'',
      selectedFilvalue:'',
      popularCheckSt: 0,
    };

    //this.props.getCarList(qs.stringify(postobject));
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentDidMount() {
    this.listloadedData()
  }
   
  listloadedData(postobject='') {
    var qs = require('qs');
    if(postobject!=''){
      var postobject = postobject
    }else{
      var postobject = {
        activePage: this.state.activePage,
        search_all: '',
        admin_id: localStorage.getItem('admin_id')  
      };
    }

    axios.post(apiUrl+"popularcity/list",qs.stringify(postobject)).then(res => {
      if(res.data.status === 'success'){          
        this.setState({citylist: res.data, totalRecord: res.data.records_count}, function() {
          this.citylist();
        });
      }else{
        this.setState({  citylist: '', totalRecord: 0}, function() {
          this.citylist();
        });
      }
    }); 
  }

  handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
    this.setState({activePage: pageNumber});

    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var postobject = {
      activePage: pageNumber,
      search_all: this.state.search_all,
      admin_id: admin_id
    };
    this.listloadedData(postobject);
    // this.props.getCarList(qs.stringify(postobject))
  }

  handleInputChange(event) {
    const {name, value} = event.target;      
    this.setState({
      [name]: value
    });
    var postObject = {             
      activePage   : this.state.activePage,
      search_all : value,
      admin_id: localStorage.getItem('admin_id')           
    };
    this.listloadedData(postObject)
  }
  handleFormSubmit = () => {
    this.setState({Loading:true});
    var qs = require('qs');    
    var admin_id = localStorage.getItem("admin_id");
    var postObject = {             
      activePage   : 1,
      search_all : this.state.search_all,
      filterVal : this.state.selectedFilvalue,
      admin_id: admin_id         
    };
		this.listloadedData(postObject);  
  }    

	deletecity(id){
    var qs = require('qs');
    var postObject = {
      admin_id : localStorage.getItem("admin_id"),
      id  :id
    };
    //this.props.getDeleteCar(qs.stringify(postObject));
    this.setState({cityid : id})
    $('.confirm-action-delete-message').html('Are you sure! you want to delete the city?');	
    $('.confirm-action-delete').addClass('show');	
	}

  handlePopular = (id, isChecked) => {
    const qs = require('qs');
    const postObject = {
      id: id,
      popularCheckSt: isChecked ? 1 : 0,
      admin_id: localStorage.getItem("admin_id")
    };

    axios.post(apiUrl + "popularcity/setPopular", qs.stringify(postObject))
      .then(res => {
        if(res.data.status === 'success'){
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
          setTimeout(function() {
            $('.success_message').html('');
          }.bind(this),3000);
          this.listloadedData();
        } else {
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
          setTimeout(function() {
            $('.success_message').html('');
          }.bind(this),3000);          
        }
      })
      .catch(err => {          
      });
  };

  citylist() {	 
    var citylist = this.state.citylist;
    if (citylist != "undefined" && citylist != null) {
      if (citylist.status == "success") {
        if (Object.keys(citylist).length > 0) {
          const citylistDetails = citylist.citylist.map(
            (citylist, Index) => {
              let sno = Index+1;
              if(citylist.status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
			  			  
			        var istyle = { width: 100};
              return (
                <tr key={citylist.id}>
                  <td>{sno}</td>
                  <td>{citylist.address}</td>              
                  <td>{citylist.cityName}</td>   
                  <td>{citylist.iata}</td>
                  <td>{status}</td>
                  <td>
                    <input type="checkbox" name="popularCheckSt" 
                    checked={citylist.popularCheckSt == 1}
                    onChange={(e) => this.handlePopular(citylist.id, e.target.checked)}
                    />
                  </td>
                  {(localStorage.getItem("admin_id") == 1) &&
                  <td className="actiongroup">
                    <Link to={{ pathname: '/popularcity-edit/'+citylist.id}} className="" title="Duplicate">  <i className="fa fa-edit" aria-hidden="true"></i></Link>
                    <Link onClick={this.deletecity.bind(this,citylist.id)} className="" title="Duplicate">  <i className="fa fa-trash" aria-hidden="true"></i></Link>
                  </td>}
                </tr>
              );
            }
          );
          return citylistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="9" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }
  }
  deleteConfirm =(confirmstatus,id)=>{
    if(confirmstatus == 'yes'){
			$('.confirm-action-delete').removeClass('show');
      var qs = require('qs');       
      var postObject = { 
        column: 'id',         
        value: id,   
        activePage:this.state.activePage,  
        admin_id:localStorage.getItem("admin_id")
      };
      axios.post(apiUrl+"popularcity/delete",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
          setTimeout(function() {
            $('.success_message').html('');
          }.bind(this),3000);
          this.listloadedData()
        }
      });  
    }else{
      $('.confirm-action-delete').removeClass('show');	
    }
  }
  handleFilChange = (selOption) => {       	
    this.setState({selectedFilOption:selOption})
    this.setState({  selectedFilvalue : selOption.value},function(){
      this.handleFormSubmit()
    });
  };
  
  render() {
    return (
      <div className="wrapper"> 
        <Header />
        <MenuSidebar currentpage="popularcity"  currentTab="car" />  
        <div className="content"> 
          <div className="content-wrapper">
            <div className="car-listing-wrap">
              <div className="success_message"></div>
              <div className="listing-header">
                <div className="title">
                  <h3>{this.state.totalRecord} International Airport{this.state.totalRecord>1 ? 's' : ''} </h3>
                </div>
                <div className='listing-header-right-sec d-flex justify-content-end gap-2 w-100'>
                  <div className="search-list">
                    <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="input_search">
                          <div className="search-inner search_input">
                            <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                            <button className="" type="submit">Submit</button>
                            <div className="erroremail"></div>
                          </div>
                          <div className="search-inner search_select">
                          <Select name="category" options={lang.common.status_filter_option} 
                            //onChange={this.handleInputChange}
                            onChange={this.handleFilChange.bind(this)}
                          />
                        </div>  
                    </div>
                  </form>
                  </div>
                  <div className="add_button">  
                      <a className="primary-btn" href='/popularcity-add'>Add</a> 
                  </div>  
                </div>  
              </div>            
              {/*<div className="statusmessage"></div>*/}

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Airport</th>
                      <th>Location</th>
                      <th>IATA</th> 
                      <th>Status</th>
                      <th>Set as popular</th>
                      {(localStorage.getItem("admin_id") == 1) &&
                      <th>Action</th>
                      }
                    </tr>
                  </thead>
                  <tbody>{this.citylist()}</tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
          </div>  
        </div>
      
        <div className="confirm-action-delete">
          <p className="confirm-action-delete-message"></p>
          
          
          <a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.cityid)} className="btn">Yes</a>
          <a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
          <span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
        </div>
      </div>
    );
  }
}

export default withRouter(List);
/*
const mapStateTopProps = (state) => {
  return {
    carlist: state.carlist,
    deletecar: state.deletecar,
	  priorityupdate: state.priorityupdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCarList: (formVal) =>{
       dispatch({ type: GET_CARLIST, formVal});
    },
    getDeleteCar: (formPayload) =>{
      dispatch({ type: GET_DELETECAR, formPayload });
    },	
	getPriorityUpdate: (formPayload) =>{
      dispatch({ type: GET_PRIORITYUPDATE, formPayload });
    }
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));*/